export default rawCss => {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = rawCss;
    document.getElementsByTagName('head')[0].appendChild(style);
};